import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ConsentBanner } from "./ConsentBanner";

export const SiteLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <ConsentBanner />
    </div>
  );
};
